export default "__VITE_ASSET__ExLLiLWw__"